import Widget from "../../commons/base/widget";
import FormButton from "../../commons/ui/form_button";
import SizedDiv from "../../commons/ui/sized_div";
import WebRedirectFormScreen from "../screens/web_redirect_form_screen";
import WebRedirectFormState from "../view_models/web_redirect_form_state";
import WebRedirectFormViewModel from "../view_models/web_redirect_form_view_model";

export default class WebRedirectFormResultWidget extends Widget<{}, WebRedirectFormState, WebRedirectFormViewModel, WebRedirectFormScreen> {
    render() {
        return <>
            <p style={{
                fontSize: 16,
                fontWeight: 700
            }}>Link Web View:</p>
            <a 
                href={this.vmState.webViewLink} 
                style={{
                    fontSize: 14,
                    color: "white",
                    textAlign: "start"
                }}
                target="_blank"
                rel="noreferrer" 
            >{this.vmState.webViewLink}</a>
            <SizedDiv height={24} />
            <FormButton 
                title="Buat Redirect Web Lagi"
                action={() => this.viewModel.reset()}
            />
        </>;
    }
}
